import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getNotifications } from '../../utilities/api';

export const fetchNotifications = createAsyncThunk('notifications/fetch', async (params = {}, { rejectWithValue }) => {
    try {
        const data = await getNotifications(params);
        return data;
    } catch (error) {
        return rejectWithValue(error.message || 'Failed to fetch notifications');
    }
});

const initialState = {
    notificationsData: [],
    loading: false,
    error: null
};

const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchNotifications.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNotifications.fulfilled, (state, action) => {
                state.loading = false;
                const raw = action.payload;
                const data = Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : [];
                state.notificationsData = data.map((n) => ({
                    ...n,
                    status: n.status || 'Active'
                }));
            })
            .addCase(fetchNotifications.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.notificationsData = [];
            });
    }
});

export const { clearError } = notificationsSlice.actions;

export const selectNotificationsData = (state) => state.notifications.notificationsData;
export const selectLoading = (state) => state.notifications.loading;
export const selectError = (state) => state.notifications.error;

export default notificationsSlice.reducer;
